import React from "react";
import { Line } from "react-chartjs-2";

const LineChart = (props) => {
  const { title, unit, reading, lineColour, background, min, max, step } =
    props;
  // console.log("Graph Reading", reading);
  let label = [];
  for (var i = 1; i <= reading.length; i++) {
    label.push(i);
    // console.log("Graph Label", label);
  }
  const data = {
    // labels: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "Today"],
    labels: label,
    datasets: [
      {
        label: unit ? `${title}` : `${title}`,
        data: reading,
        fill: false,
        backgroundColor: background,
        borderColor: lineColour,
        // backgroundColor: "rgb(255, 99, 132)",
        // borderColor: "rgba(255, 99, 132, 0.2)",
      },
    ],
  };

  const options = {
    scales: {
      y: {
        min: min,
        max: max,
        ticks: {
          stepSize: step,
          beginAtZero: true,
        },
      },
      // yAxes: [
      //   {
      //     ticks: {
      //       beginAtZero: true,
      //     },
      //   },
      // ],
    },
  };

  return (
    <div className="tw-font-nunito tw-py-3 tw-m-3 sm:tw-w-2/5 tw-w-4/5">
      <div className="header">
        <div className="tw-text-center sm:tw-text-3xl tw-text-2xl">{title}</div>
      </div>
      <Line data={data} options={options} />
    </div>
  );
};

export default LineChart;

// https://github.com/reactchartjs/react-chartjs-2/blob/master/example/src/charts/Line.js"
